"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
        funcs[_key] = arguments[_key];
    }

    if (funcs.length === 0) {
        return function (arg) {
            return arg;
        };
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce(function (a, b) {
        return function (item) {
            return a(b(item));
        };
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/compose.js
// module id = 911
// module chunks = 35783957827783